<template>
    <ul
        v-if="filterTags.length"
        class="l-ss-c-filter-tags"
        :class="{ 'l-ss-c-filter-tags-indented': filterPositionLeft }">
        <li
            v-for="tag in filterTags"
            :key="`filter-tag-${tag.id}`"
            class="l-ss-c-filter-tags-item"
            @click="onFIlterTagClick(tag)">
            <span>{{ tag.value }}</span>
            <i
                v-html="iconCloseThin"
                class="l-ss-c-icon"></i>
        </li>
        <li
            v-if="isShowResetButton"
            class="l-ss-c-filter-tags-reset-button"
            @click="$emit('reset-filters')">
            <span>{{ $t('filters.resetAllText') }}</span>
        </li>
    </ul>
</template>

<script>
    import iconCloseThin from '@/core/assets/images/icons/close-thin.svg';

    export default {
        props: {
            activeFilters: {
                type: Array,
                default: () => ([]),
            },
            filters: {
                type: Array,
                default: () => ([]),
            },
            filterPositionLeft: {
                type: Boolean,
                default: false,
            },
            symbol: {
                type: String,
                default: '',
            },
        },
        computed: {
            iconCloseThin() {
                return iconCloseThin;
            },
            isShowResetButton() {
                return Boolean(this.filterTags?.length > 1);
            },
            categoriesNameMap() {
                let map = {};
                const categoryFilter = this.filters.find(item => item.id === 'category');
                const categoryFilterOptions = categoryFilter?.options || [];

                map = categoryFilterOptions.reduce((accumulator, currentOption) => {
                    accumulator[currentOption.id] = currentOption.name;
                    return accumulator;
                }, {});

                return map;
            },
            filterTags() {
                const tags = [];

                if (this.activeFilters?.length) {
                    this.activeFilters.forEach((filterItem, filterIndex) => {
                        const tag = {};
                        tag.filterIndex = filterIndex;
                        tag.field = filterItem.field;

                        if (filterItem.options) {
                            filterItem.options.forEach((optionItem, optionIndex) => {
                                const newTag = {};
                                newTag.optionIndex = optionIndex;
                                newTag.value = filterItem.field === 'category' ? this.getTagValue(optionItem) : optionItem;
                                newTag.id = crypto.randomUUID();
                                newTag.filterIndex = filterIndex;
                                newTag.field = filterItem.field;

                                if (newTag.value) {
                                    tags.push(newTag);
                                }
                            });
                        } else if (filterItem.condition === 'range') {
                            tag.min = filterItem.min;
                            tag.max = filterItem.max;

                            if (filterItem.min && filterItem.max) {
                                tag.value = `${filterItem.min} - ${filterItem.max}`;
                            } else if (filterItem.min) {
                                tag.value = `${this.$t('filters.from')} ${filterItem.min}`;
                            } else if (filterItem.max) {
                                tag.value = `${this.$t('filters.to')} ${filterItem.max}`;
                            }
                            tag.id = crypto.randomUUID();
                            tags.push(tag);
                        } else if (filterItem.field === '_is_available') {
                            if (filterItem.value) {
                                tag.value = this.$t('filters.byType._is_available').checked;
                                tag.id = crypto.randomUUID();
                                tags.push(tag);
                            }
                        }
                    });
                }

                return tags;
            },
        },
        methods: {
            getTagValue(value) {
                if (this.categoriesNameMap[value]) {
                    return this.categoriesNameMap[value];
                }
                return '';
            },
            onFIlterTagClick(tag) {
                const params = {
                    field: tag.field,
                };

                if (tag.optionIndex !== undefined && tag.filterIndex !== undefined) {
                    if (this.activeFilters[tag.filterIndex].options.length > 1) {
                        const newOptions = this.activeFilters[tag.filterIndex].options.toSpliced(tag.optionIndex, 1);
                        params.options = newOptions;
                    }
                }

                this.$emit('change', params);
            },
        },
    };
</script>
